module.exports = __webpack_public_path__ + "img/blue_052.e94c560d.png";